import { string, object, number, ObjectSchema, array } from 'yup';

import { IIpadConfigUpdate } from '@/features/ipad-configs/interfaces';
import { ERROR_MAX_LENGTH, ERROR_REQUIRED_FIELD } from '@/constants';
import { AccessControlMode, DeviceType } from '@/features/ipad-configs/enums';
import {
  IPAD_CONFIG_PROJECT_NAME_MAX_LENGTH,
  IPAD_CONFIG_REMARKS_MAX_LENGTH,
} from './ipadConfig.constants';

export const IPAD_CONFIG_CREATION_SCHEMA = object({
  serialNumber: string().required(ERROR_REQUIRED_FIELD),
  deviceType: number().required(ERROR_REQUIRED_FIELD),
  projectName: string().when('deviceType', {
    is: (val: number) => val === DeviceType.ProjectRoom,
    then: (schema) =>
      schema
        .required(ERROR_REQUIRED_FIELD)
        .max(
          IPAD_CONFIG_PROJECT_NAME_MAX_LENGTH,
          ERROR_MAX_LENGTH(IPAD_CONFIG_PROJECT_NAME_MAX_LENGTH),
        ),
  }),
  accessControlMode: number().when('deviceType', {
    is: (val: number) => val === DeviceType.ProjectRoom,
    then: (schema) => schema.required(ERROR_REQUIRED_FIELD),
  }),
  allowMembers: array().when(['deviceType', 'accessControlMode'], {
    is: (deviceType: number, accessControlMode: number) =>
      deviceType === DeviceType.ProjectRoom &&
      accessControlMode === AccessControlMode.RestrictedAccess,
    then: (schema) => schema.required(ERROR_REQUIRED_FIELD).min(1, ERROR_REQUIRED_FIELD),
  }),
  remarks: string().max(
    IPAD_CONFIG_REMARKS_MAX_LENGTH,
    ERROR_MAX_LENGTH(IPAD_CONFIG_REMARKS_MAX_LENGTH),
  ),
}) as ObjectSchema<IIpadConfigUpdate>;
